module.exports = __webpack_public_path__ + "static/media/video puisi rumasuar.bbb40121.mp4";